// Externals
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { compose } from 'redux';
// Actions
import { redirectToSearch } from '../../actions/collection';
import { getDynamicBffUrl } from '../../middleware/bffUrlMiddleware';
// Contants
import { withCurrency } from '../currency';
// Selectors
import { selectSession } from '../../selectors/session';

// Components
import { LandingPage as LandingPageComponent } from '@homeexchange/landing-page';

export const LandingPage = (props) => {
    const { currency, localeDescription, session } = props;

    return (
        <LandingPageComponent
            type="collection"
            config={{
                apiUrl: getDynamicBffUrl(process.env.URL_BFF),
                assetsUrl: process.env.URL_MIGRATION_ASSETS,
                jawgToken: process.env.JAWG_KEY,
                jawgUrl: process.env.URL_JAWG_URL,
                locale: localeDescription,
                currency: currency,
                session: session
            }}
        />
    );
};

LandingPage.propTypes = {
    localeDescription: PropTypes.string,
    currency: PropTypes.string,
    session: PropTypes.object
};

const mapStateToProps = (state) => ({
    localeDescription: state.localeDescription,
    currency: state.currency,
    session: selectSession(state)
});

const mapDispatchToProps = (dispatch) => ({
    redirectToSearch: bindActionCreators(redirectToSearch, dispatch)
});

export default compose(connect(mapStateToProps, mapDispatchToProps), withCurrency)(LandingPage);
